import React, { useState } from 'react'
import SvgTrash from 'src/components/Svgs/SvgTrash'
import SvgTrashHover from 'src/components/Svgs/SvgTrashHover'
import { css } from 'styled-components'

interface TrashButtonProps {
  className?: string
  onClick: () => void
  disabled?: boolean
}

const TrashButton: React.FC<TrashButtonProps> = (props): React.ReactElement => {
  const [hovering, setHovering] = useState<boolean>(false)

  return (
    <div
      className={props.className}
      css={css`
        height: 20px;
        width: 20px;
        cursor: pointer;
        ${props.disabled && `pointer-events: none;`}
      `}
      onClick={props.onClick}
      onKeyPress={props.onClick}
      role="button"
      tabIndex={0}
      onMouseEnter={(): void => setHovering(true)}
      onMouseLeave={(): void => setHovering(false)}
    >
      {hovering ? (
        <SvgTrashHover
          css={css`
            transform-origin: top;
            transform: scale(calc(20 / 24));
          `}
        />
      ) : (
        <SvgTrash
          css={css`
            transform-origin: top;
            transform: scale(calc(20 / 24));
          `}
        />
      )}
    </div>
  )
}

export default TrashButton
